import { render } from "./CustomObjectItem.vue?vue&type=template&id=600baa95&scoped=true"
import script from "./CustomObjectItem.vue?vue&type=script&lang=js"
export * from "./CustomObjectItem.vue?vue&type=script&lang=js"

import "./CustomObjectItem.vue?vue&type=style&index=0&id=600baa95&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600baa95"]])

export default __exports__